import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Activity } from 'src/app/model/options/activity';
import { Service } from 'src/app/model/options/service';
import { ExpressionOperator } from 'src/app/model/search-filters/expression-operator';
import { Filter } from 'src/app/model/search-filters/filter';
import { SearchFilterUtils } from 'src/app/model/search-filters/search-filter-utils';
import { StudioType } from 'src/app/model/studio-type';

export type AddFilterDialogData = {
  studioTypes: StudioType[];
  activities: Activity[];
  services: Service[];
  gymEquipments: string[];
  gymInfos: string[];
  gymTypes: string[];
  networks: string[];
  equipmentsToBring: string[];
  geniusFeatures: string[];
};

@Component({
  selector: 'gymfinder-add-filter-dialog',
  templateUrl: './add-filter-dialog.component.html',
  styleUrls: ['./add-filter-dialog.component.scss'],
  standalone: false,
})
export class AddFilterDialogComponent implements OnInit {
  filter: Filter;

  studioTypes: StudioType[];

  activities: Activity[];

  services: Service[];

  gymEquipments: string[];

  gymInfos: string[];

  gymTypes: string[];

  networks: string[];

  equipmentsToBring: string[];

  geniusFeatures: string[];

  constructor(
    private dialogRef: MatDialogRef<AddFilterDialogComponent>,
    @Inject(MAT_DIALOG_DATA) private data: AddFilterDialogData
  ) {}

  ngOnInit(): void {
    this.studioTypes = this.data.studioTypes;
    this.activities = this.data.activities;
    this.services = this.data.services;
    this.gymEquipments = this.data.gymEquipments;
    this.gymInfos = this.data.gymInfos;
    this.gymTypes = this.data.gymTypes;
    this.networks = this.data.networks;
    this.equipmentsToBring = this.data.equipmentsToBring;
    this.geniusFeatures = this.data.geniusFeatures;
    this.filter = {
      text: {},
      block: { operator: ExpressionOperator.AND },
    };
  }

  public createFilter() {
    this.dialogRef.close(this.filter);
  }

  public closeDialog() {
    this.dialogRef.close();
  }

  public getLogicalExpression(filter: Filter): string {
    return SearchFilterUtils.toLogicString(filter);
  }
}
